import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal, SectionHead } from "@/components/Reveal";
import { FindUs } from "@/components/home/HomeTop";
import { ContactActions, HoursList, MapFrame } from "@/components/VisitBlock";
import { BUSINESS, PAGES } from "@/lib/site";
import { CategoryLinks } from "@/components/InlineLinks";
import { track } from "@/lib/analytics";

const CRUMBS = [{ name: "Home", path: "/" }, { name: "Location & Hours", path: "/location" }];

export default function Location() {
  return (
    <>
      <Seo {...PAGES.location} path="/location" crumbs={CRUMBS} />
      <PageHeader crumbs={CRUMBS} eyebrow="Location & hours" title="We're upstairs at" highlight="1738 14th St NW" image="/img/storefront.webp" lead="Right next to Chicken + Whiskey in Logan Circle. Take the first door on the left, head up the stairs and ring the doorbell.">
        <div className="mt-8"><ContactActions where="location-hero" dark /></div>
        <Link to="/areas-we-serve" data-testid="location-areas-link" className="mt-5 inline-block text-sm font-bold text-brand-lime underline underline-offset-4">Directions from your neighborhood</Link>
      </PageHeader>
      <FindUs />
      <section className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 sm:py-28 lg:grid-cols-12" data-testid="location-details">
        <Reveal className="lg:col-span-7"><MapFrame className="h-[380px] sm:h-[520px]" /></Reveal>
        <div className="space-y-12 lg:col-span-5">
          <Reveal>
            <SectionHead eyebrow="Store hours" title="Open every day" />
            <div className="mt-6"><HoursList /></div>
          </Reveal>
          <Reveal delay={0.08}>
            <SectionHead eyebrow="Contact" title="Questions before you visit?" />
            <div className="mt-6 space-y-3 text-sm">
              <a href={`mailto:${BUSINESS.email}`} onClick={() => track("email_click", { location: "location" })} data-testid="location-email-link" className="flex items-center gap-3 break-all font-semibold hover:text-brand-red"><Mail className="h-4 w-4 shrink-0" />{BUSINESS.email}</a>
              <a href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer" data-testid="location-instagram-link" className="flex items-center gap-3 font-semibold hover:text-brand-red"><Instagram className="h-4 w-4" />@districtgaslightdc</a>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-neutral-600" data-testid="location-links">
              Before you come: <Link to="/medical-card" className="font-bold text-brand-red">get your medical card</Link>, browse <CategoryLinks /> on the live menu, and check <Link to="/special-deals" className="font-bold text-brand-red">today's deals</Link>.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="bg-brand-lime">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-6 px-4 py-14 sm:px-6 md:flex-row md:items-center">
          <h2 className="max-w-xl font-display text-3xl font-black tracking-tight">Skip the wait — order ahead before you head over.</h2>
          <Link to="/shop-all" onClick={() => track("shop_now_click", { location: "location" })} data-testid="location-shop-button" className="btn-dark self-start md:self-auto">Shop now</Link>
        </div>
      </section>
    </>
  );
}
